<template>
<b-sidebar
    id="sub-category-form-sidebar"
    :visible="isSubCategoryFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(subCategoryData)"
    @hidden="resetForm(resetData)"
    @change="(val) => $emit('update:is-sub-category-form-sidebar-active', val)"
>
    <template #default="{ hide }"> 
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
            <h5 class="mb-0">
                Food Sub Category Form
            </h5>
    
            <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="close(hide)"
            />
        </div>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver" >
            <b-form
                class="p-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
            >
                <b-tabs content-class="mt-1" v-if="langs.length > 0">
                    <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">
                        <validation-provider
                            #default="validationContext"
                            :name="'title_'+lang.code"
                            rules="min:0"
                        >
                            <b-form-group
                                label="Title"
                                :label-for="'title_'+lang.code"
                            >
                                <b-form-input
                                    :id="'title_'+lang.code"
                                    v-model="Data.title[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Title ('+lang.code+')'"
                                    @input="changeTitle(lang.code)"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="validationContext"
                            :name="'slug' + lang.code"
                            rules="required"
                        >
                            <b-form-group
                                label="Slug"
                                :label-for="'slug' + lang.code"
                            >
                                <b-form-input
                                    :id="'slug' + lang.code"
                                    v-model="Data.slug[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Slug (' + lang.code + ')'"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-tab>
                </b-tabs>
                <hr />
                <validation-provider
                    #default="validationContext"
                    name="food_category_id"
                    rules="required"
                >
                    <b-form-group label="Categories" label-for="food_category_id">
                        <v-select
                            id="food_category_id"
                            v-model="Data.categories"
                            multiple
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="title"
                            :reduce="(option) => option.id"
                            :options="categoryData.map((g) => ({
                                title: g.title[currentLocale],
                                id: g.id
                            }))"
                        />
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                <div>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="outline-primary"
                        class="mr-2"
                        @click="uploadImage('image')"
                    >
                        Upload Image
                    </b-button>
                    <file-lists
                        :is-modal-file-lists-show.sync="isModalFileListsShow"
                        :uploadType="uploadType"
                        @refesh="refesh"
                    />
                </div>
                <br/>
                <div>
                    <validation-provider
                        #default="validationContext"
                        name="cover_image_id"
                        rules="required"
                    >
                        <b-form-group label="Cover Image" label-for="image">
                            <div id="cover_image_id">
                                <treeselect 
                                    @input="eventSelected"
                                    v-model="model" 
                                    placeholder="Choose Folder"
                                    :reduce="(option) => option.id"
                                    label="title"
                                    :options="folderOptions"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    noChildrenText
                                />
                            </div>
                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <div v-if="images.length">
                        <b-container align-h="center">
                            <b-row>
                                <b-col 
                                    cols="3"
                                    v-for="(image, index) in images"
                                    :key="index"
                                    class="pt-2"
                                >
                                <img 
                                    @click="eventImgSelected(image)"
                                    :src="image.path"
                                    width="300"
                                    height="200"
                                    :class="selectedImages.some(v => v.id === image.id)? 'selected-img' : ''"
                                >
                                <br/>
                            </b-col>
                            <hr/>
                            </b-row>
                        </b-container>
                        <br/>
                    </div>
                </div>
                <validation-provider
                    #default="validationContext"
                    name="IsActive"
                    rules="min:0"
                >
                    <b-form-group
                        label="Is Active"
                        label-for="IsActive"
                    >
                        <b-form-checkbox
                            id="isactive"
                            checked="true"
                            class="custom-control-success"
                            v-model="Data.is_active"
                            switch
                        />
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                <div class="d-flex mt-2">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-2"
                        type="submit"
                    >
                        Submit
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        type="button"
                        variant="outline-secondary"
                        @click="close(hide)"
                    >
                        Cancel
                    </b-button>
                </div>
            </b-form>
        </validation-observer>
    </template>
</b-sidebar>
</template>
    
<script>
    import { $themeConfig } from '@themeConfig'
    import {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton, BTabs, BTab,
        BContainer, BRow, BCol,
    } from 'bootstrap-vue'
    import { useToast } from "vue-toastification/composition";
    import { slugify } from '@/@fake-db/utils'
    import { ref, onUnmounted } from '@vue/composition-api'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { getCurrentInstance } from '@vue/composition-api'
    import Ripple from 'vue-ripple-directive'
    import formValidation from '@core/comp-functions/forms/form-validation'
    import languagesStoreModule from '@/views/languages/languagesStoreModule'
    import vSelect from 'vue-select'
    import store from '@/store'
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import FileLists from '../../uploadStorage/FileLists.vue'
    import folderStoreModule from '@/views/files/folderStoreModule';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Treeselect from '@riophae/vue-treeselect'

    export default {
        components: {
            BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton, vSelect,
            BTabs, BTab, ValidationProvider, ValidationObserver, FileLists, BContainer, BRow, Treeselect,
            BCol,
        },
        directives: {
            Ripple,
        },
        model: {
            prop: 'isSubCategoryFormSidebarActive',
            event: 'update:is-sub-category-form-sidebar-active',
        },
        props: {
            isSubCategoryFormSidebarActive: {
                type: Boolean,
                required: true,
            },
            subCategoryData: {
                type: Object,
                required: false,
            },
        },
        computed: {
            folderOptions(){
                return this.folders.map((folder) => this.formatFolder(folder))
            },
            currentLocale(){
                return this.$i18n.locale;
            },
        },
        methods:{
            formatFolder(folder){
                return{
                    id: folder.id,
                    label: folder.title,
                    children: folder.subFolders.length? folder.subFolders.map(this.formatFolder): undefined
                }
            },
        },
        setup(props, { emit }){
            const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
            if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
            
            const FOLDER_STORE_MODULE_NAME = 'files-folder'
            if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
        
            const CAT_STORE_MODULE_NAME = 'app-food';
            if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, foodStoreModule)

            onUnmounted(() => {
                if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
                if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
                if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
            });

            const toast = useToast();
            const currentLocale = getCurrentInstance().proxy.$i18n.locale
            const userStorage = JSON.parse(localStorage.getItem('userData'));
            const getLocalSite = JSON.parse(localStorage.getItem('site'))
            const langs = ref([]);
            const blankData = {
                created_by: userStorage.id,
                slug: {},
                title: {},
                is_active: true,
                ordering_count: 0,
                sites_id: getLocalSite.id,
                categories: [],
                files: [],
            }

            const Data = ref(blankData)
            const tabIndex = ref(0);
            const oldValue  =  ref(null)
            const isModalFileListsShow = ref(false)
            const uploadType = ref('')
            const model = ref(null)
            const images = ref([])
            const selectImages = ref([])
            const folders = ref([])
            const selectCoverImage = ref(null)
            const categoryData = ref([])
            const selectedImages = ref([])
            const parent = ref(0);

            store.dispatch('app-food/getFoodCategories', {
                sites_id: getLocalSite.id
            })
            .then(response => {
                categoryData.value = response.data.data
            })

            const resetData = () => {
                Data.value = blankData
            }

            const close = (hidden) => {
                
                for(const lang in oldValue.value?.title ?? {}) {
                    Data.value.title[lang] = oldValue.value.title[lang]
                }

                 for(const lang in oldValue.value?.slug ?? {}) {
                    Data.value.slug[lang] = oldValue.value.slug[lang]
                }

                hidden()
            }

            const changeTitle  = (lang) => {
                if(lang){
                    Data.value.slug[lang] = slugify(Data.value.title[lang]);
                }
            }

            const getLangs = (filter)=>{
                store.dispatch('app-languages/fetchData', filter)
                    .then((res) => {
                        if(res.data.success){
                            langs.value = res.data.data;
                        }  
                });
            }

            let filter = {
                is_active: 1
            }

            getLangs(filter);

            const refeshList = async () => {
                emit("refetch-data");
            };

            const getData = async (data) => {
                tabIndex.value = 0;
                const locale = currentLocale

                if(data) {
                    data.is_active = data.is_active? true: false

                    Data.value = {
                        ...data,
                        categories: Array.isArray(data.categories)? data.categories.map((g) => {
                            return {
                                title: g.title[locale],
                                id: g.id, 
                            }
                        })
                        : []
                    }

                    const files = data?.files
                    const folderId = files.length? files[0].folder_id: null
                    model.value = folderId

                    if(folderId){
                        await store.dispatch('files-folder/getFolderById', folderId)
                            .then(response => {
                                const res = response.data.data
                                const responseImages = res[0].images

                                const filterData = responseImages.filter(v => data?.files.some(m => m.id === v.id));
                                selectedImages.value = filterData
                            }
                        )
                    }
                    

                    oldValue.value = JSON.parse(JSON.stringify({...data}))
                } else {
                    Data.value = blankData
                    images.value = []
                    selectedImages.value = []
                    model.value = null
                }
            }

            const onSubmit = async () => {
                Data.value.files = selectedImages.value

                if(!Data.value.id){
                    try {
                        const insertData = await store.dispatch('app-food/addSubCategoryData', Data.value)

                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${insertData?.data?.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-sub-category-form-sidebar-active', false)
                    } catch(error) {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Error`,
                                icon: 'BellIcon',
                                variant: 'danger',
                                text: error?.response?.data?.message || error,
                            },
                        });
                    }
                } else {
                    Data.value.updated_by = userStorage.id

                    try {
                        const insertData = await store.dispatch('app-food/updateSubCategoryData', Data.value)

                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${insertData?.data?.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-sub-category-form-sidebar-active', false)
                    } catch(error) {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Error`,
                                icon: 'BellIcon',
                                variant: 'danger',
                                text: error?.response?.data?.message || error,
                            },
                        });
                    }
                }
            }

            const refesh = () => {
                store.dispatch('files-folder/getFolders', {
                    parent: parent.value,
                    order_by:'ordering_count ASC'
                })
                    .then(response => {
                        const res = response.data.data
                        folders.value = res
                })

                model.value = null
                images.value = []
                selectedImages.value = []
            }

            const eventSelected = (id) => {
                store.dispatch('files-folder/getFolderById', id)
                    .then(response => {
                        const res = response.data.data
                        images.value = res.length? res[0].images: []

                        const existingFolderId = Data?.value?.files[0]?.folder_id || ''

                        if(model.value != existingFolderId){
                            // selectCoverImage.value = null
                            selectedImages.value = []
                        }
                })
            }

            const eventImgSelected = (data) => {
                const index = selectedImages.value.findIndex(item => item.id === data.id);
                index === -1 ? selectedImages.value.push(data) : selectedImages.value.splice(index, 1);
            }

            const uploadImage = (type) => {
                uploadType.value = type
                isModalFileListsShow.value = true
            }

            const {
                refFormObserver,
                getValidationState,
                resetForm,
            } = formValidation(resetData)

            return {
                refFormObserver,
                getValidationState,
                resetForm,
                langs,
                Data,
                resetData,
                tabIndex,
                close,
                getData,
                changeTitle,
                onSubmit,
                refeshList,
                isModalFileListsShow,
                uploadType,
                refesh,
                model,
                images,
                selectImages,
                folders,
                eventSelected,
                selectCoverImage,
                eventImgSelected,
                categoryData,
                uploadImage,
                selectedImages,
                parent,
            }
        }
    }
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";

    .selected-img{
        border: solid 5px #FFB341;
    }

    .disable-img{
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>